import type { Component } from "solid-js";
import type { IconProps } from "./types";

const AgentIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      width={size}
      height={size}
      class={props.class}
      stroke="currentColor"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M7.9987 8.66732C8.36689 8.66732 8.66536 8.36884 8.66536 8.00065C8.66536 7.63246 8.36689 7.33398 7.9987 7.33398C7.63051 7.33398 7.33203 7.63246 7.33203 8.00065C7.33203 8.36884 7.63051 8.66732 7.9987 8.66732Z" />
      <path d="M13.4694 13.4694C14.8301 12.1154 13.4827 8.56028 10.4679 5.5321C7.43972 2.51725 3.8846 1.16991 2.53059 2.53059C1.16991 3.8846 2.51725 7.43972 5.5321 10.4679C8.56028 13.4827 12.1154 14.8301 13.4694 13.4694Z" />
      <path d="M10.4679 10.4679C13.4827 7.43972 14.8301 3.8846 13.4694 2.53059C12.1154 1.16991 8.56028 2.51725 5.5321 5.5321C2.51725 8.56028 1.16991 12.1154 2.53059 13.4694C3.8846 14.8301 7.43972 13.4827 10.4679 10.4679Z" />
    </svg>
  );
};

export default AgentIcon;
